// extracted by mini-css-extract-plugin
export default {"currencySelectorContainer":"styles_currencySelectorContainer__rwBGU","currencySelect":"styles_currencySelect__46sjC","customSelect":"styles_customSelect__itoOm"};